import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'get-brand-context' as const;

const argumentZod = z.object({});

export const getBrandContextManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get brand context',
  family: 'brand',
  llmTool: {
    name: toolName,
    description:
      'Gets the brand for the current site, including contact info, about, locations, people, competitors, and all tracked domains (custom domains, external domains, and the webflow subdomain).',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AEO_MEASUREMENT,
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetBrandContextArgumentType = z.infer<typeof argumentZod>;
